import type { FieldErrors, FieldValues } from 'react-hook-form';

export interface FormErrorEntry {
  /** 점 표기 경로 — 예: `listPrice`, `prices.KRW.saleAmount`, `variants.0.label`. */
  path: string;
  /** 스키마가 준 메시지. i18n 키(`products.errors.*`)이거나 zod 기본 문장이다. */
  message: string;
}

/**
 * react-hook-form 의 중첩 오류 객체를 [경로, 메시지] 목록으로 편다(렌더 순서가 아니라 객체 순서).
 *
 * 입력칸이 있는 필드는 그 아래에 오류가 뜨지만, **입력칸이 없는 필드**에서 실패하면 화면에 아무것도
 * 보이지 않는다 — 제출 실패를 알리려면 오류가 어디서 났는지 경로로라도 꺼내야 한다.
 */
export const collectFormErrors = <T extends FieldValues>(errors: FieldErrors<T>): FormErrorEntry[] => {
  const out: FormErrorEntry[] = [];
  const walk = (node: unknown, path: string[]) => {
    if (node == null || typeof node !== 'object') return;
    const rec = node as Record<string, unknown>;
    if (typeof rec.message === 'string' && rec.message !== '') {
      out.push({ path: path.join('.'), message: rec.message });
    }
    for (const [key, child] of Object.entries(rec)) {
      // RHF 가 오류 노드에 붙이는 메타 필드는 건너뛴다.
      if (key === 'message' || key === 'type' || key === 'ref' || key === 'types' || key === 'root') continue;
      walk(child, [...path, key]);
    }
  };
  walk(errors, []);
  return out;
};
